<template lang="pug">
  div
    ods-dialog(
      :visible.sync="dialogSuccess"
      :append-to-body="true"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      center
      width="420px")
      span
        img.pictogram-pic-map(
          :src="require('@/assets/icons/pic_hands.svg')"
          alt="Error")
        p.no-se-han-encontrado Los cambios han sido guardados con éxito
</template>

<script type="text/javascript">
export default {
  props: {
    dialogSuccess: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog () {
      this.$emit('dialogClosed', false)
    }
  }
}
</script>

<style lang="scss" scoped>
  .no-se-han-encontrado {
    height: 24px;
    width: 305px;
    color: #6E767D;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
  }
  .pictogram-pic-map {
    height: 120px;
    width: 72px;
  }
</style>
